import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isObject } from 'lodash';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { Row, Column, Container } from 'web-ui-components/lib/global/layout';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { LoadingLocalTakeover } from 'web-ui-components/lib/organisms/takeovers';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import content, { contentPropTypes } from '../../content/ManagePayment.content';
import {
	handleActiveTabChange,
	handleManagePaymentFilterChange,
	handleViewMandate,
	setActivePage,
	setArchivePage,
	setActiveSortOrder,
	setArchiveSortOrder,
	getAllMandatesChunked,
} from '../../../states/managePayments/actions';
import {
	getMandateActiveTab,
	getMandateActiveFilter,
	hasIFTPayment,
	getActivePage,
	getArchivePage,
	getMandateTotals,
} from '../../../states/managePayments/selectors';

import RetryOption from '../../../sharedComponents/RetryOption/RetryOption';
import accountPropType from '../../../states/accounts/propTypes';
import ManagePaymentDetail from './ManagePaymentDetail';
import DifferenceModal from '../DifferenceModal/DifferenceModal';
import { ACTIVE_TAB } from '../../../config';

const mapState = (state) => ({
	mandateActiveTab: getMandateActiveTab(state),
	mandateActiveFilter: getMandateActiveFilter(state),
	hasIFTPayment: hasIFTPayment(state),
	mandateActivePage: getActivePage(state),
	mandateArchivePage: getArchivePage(state),
	mandateTotals: getMandateTotals(state),
});
const mapDispatch = (dispatch) => ({
	handleActiveTabChange: (activeTab) => dispatch(handleActiveTabChange(activeTab)),
	handleManagePaymentFilterChange: (activeFilter) => dispatch(handleManagePaymentFilterChange(activeFilter)),
	handleView: (mandateToView) => dispatch(handleViewMandate(mandateToView)),
	setActivePage: (pageNumber) => dispatch(setActivePage(pageNumber)),
	setArchivePage: (pageNumber) => dispatch(setArchivePage(pageNumber)),
	setActiveSortOrder: (order) => dispatch(setActiveSortOrder(order)),
	setArchiveSortOrder: (order) => dispatch(setArchiveSortOrder(order)),
	getAllMandatesChunked: () => dispatch(getAllMandatesChunked()),
});

export const PreferredActiveMandateSortColumn = 'PreferredActiveMandateSortColumn';
export const PreferredArchiveMandateSortColumn = 'PreferredArchiveMandateSortColumn';
export const getFromLocalStorage = (itemKey) => {
	if (!window.localStorage) return undefined;

	try {
		const itemRaw = window.localStorage.getItem(itemKey);
		if (itemRaw) {
			const itemParsed = JSON.parse(itemRaw);

			if (itemParsed && isObject(itemParsed)) {
				return itemParsed;
			}
		}
		return undefined;
	} catch (err) {
		console.error(err); // eslint-disable-line no-console
		return undefined;
	}
};

export class ManagePaymentLandingPage extends Component {
	constructor(props) {
		super(props);
		this.handleView = this.handleView.bind(this);
		this.showMandateDifferenceHeader = this.showMandateDifferenceHeader.bind(this);
		this.hideMandateDifferenceHeader = this.hideMandateDifferenceHeader.bind(this);
		this.renderRetryComponent = this.renderRetryComponent.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.handleTabChange = this.handleTabChange.bind(this);
		this.persistSortOrder = this.persistSortOrder.bind(this);
		this.state = {
			showMandateDiffModal: false,
		};
	}
	componentDidMount() {
		const { setActiveSortOrder, setArchiveSortOrder } = this.props;

		const preferredActiveMandateSortColumn = getFromLocalStorage(PreferredActiveMandateSortColumn);
		const preferredArchiveMandateSortColumn = getFromLocalStorage(PreferredArchiveMandateSortColumn);

		if (preferredActiveMandateSortColumn) {
			setActiveSortOrder(preferredActiveMandateSortColumn);
		}

		if (preferredArchiveMandateSortColumn) {
			setArchiveSortOrder(preferredArchiveMandateSortColumn);
		}
	}

	persistSortOrder(sortColumn, forActive) {
		try {
			if (window.localStorage) {
				if (forActive) {
					localStorage.setItem(PreferredActiveMandateSortColumn, JSON.stringify(sortColumn));
				} else {
					localStorage.setItem(PreferredArchiveMandateSortColumn, JSON.stringify(sortColumn));
				}
			}
		} catch (err) {
			console.error(err); // eslint-disable-line no-console
		}
	}

	handleView(mandateToView) {
		this.props.handleView(mandateToView);
	}
	showMandateDifferenceHeader() {
		this.setState({
			showMandateDiffModal: true,
		});
	}
	hideMandateDifferenceHeader() {
		this.setState({
			showMandateDiffModal: false,
		});
	}
	renderRetryComponent() {
		const {
			handleRetry,
			content: { somethingWentWrongMsg, retryButtonLabel },
		} = this.props;
		return (
			<RetryOption handleRetry={handleRetry} message={somethingWentWrongMsg} retryButtonLabel={retryButtonLabel} />
		);
	}

	handleTabChange(activeTab) {
		const { getAllMandatesChunked, handleActiveTabChange } = this.props;

		handleActiveTabChange(activeTab);
		getAllMandatesChunked();
	}

	handlePageChange(pageNumber) {
		const { setActivePage, setArchivePage, mandateActiveTab, getAllMandatesChunked } = this.props;
		const isMandateActiveTab = mandateActiveTab === ACTIVE_TAB;

		if (pageNumber === '') return;

		isMandateActiveTab ? setActivePage(pageNumber) : setArchivePage(pageNumber);
		getAllMandatesChunked();
	}

	render() {
		const {
			content: { managePaymentHeader, managePaymentSubHeader, mandateDifferenceHeader },
			hasApiCallInProgress,
			hasError,
			handleManagePaymentFilterChange,
			mandateActiveTab,
			mandateActiveFilter,
			handleEdit,
			handleCancelView,
			handleBackParent,
			chatBox,
			hasIFTPayment,
			handleEditById,
			onDropDownChange,
			accounts,
			renderPicker,
			showPaymentDetail,
			selectedAccount,
			totalNumberOfAccounts,
			mandateActivePage,
			mandateArchivePage,
			mandateTotals,
		} = this.props;

		const { showMandateDiffModal } = this.state;
		return (
			<LoadingLocalTakeover show={hasApiCallInProgress} title="loading...">
				<Container className="manage-scheduled-payments">
					<Row>
						<Column sm="24" md="18">
							<BackButton onClick={handleBackParent} disabled={hasApiCallInProgress} />
							<PageHeading isFlush data-test-id="manage-payment-page">
								{managePaymentHeader}
							</PageHeading>
							<p className="u-margin-top-1">{managePaymentSubHeader}</p>
							<Button onClick={this.showMandateDifferenceHeader} id="difference-modal-button" size="xs">
								{mandateDifferenceHeader}
							</Button>
						</Column>
						<Column sm="24" md="6">
							{chatBox}
						</Column>
					</Row>
					{totalNumberOfAccounts > 0 && (
						<Row className="u-margin-top-2">
							<Column sm="24" md="18">
								<div className="c-field">
									<div className="c-field__controls">
										{renderPicker({
											selectedAccount,
											accountList: accounts,
											onDropdownSelect: onDropDownChange,
										})}
									</div>
								</div>
							</Column>
						</Row>
					)}
					<Row>
						<Column sm="24" md="18">
							{showPaymentDetail && (
								<ManagePaymentDetail
									activeTab={mandateActiveTab}
									handleActiveTabChange={this.handleTabChange}
									mandateActiveFilter={mandateActiveFilter}
									handleManagePaymentFilterChange={handleManagePaymentFilterChange}
									hasApiCallInProgress={hasApiCallInProgress}
									hasError={hasError}
									handleView={this.handleView}
									renderRetryComponent={this.renderRetryComponent}
									handleEdit={handleEdit}
									handleCancelView={handleCancelView}
									handleEditById={handleEditById}
									accounts={accounts}
									hasIFTPayment={hasIFTPayment}
									content={content}
									mandateActivePage={mandateActivePage}
									mandateArchivePage={mandateArchivePage}
									mandateTotals={mandateTotals}
									handlePageChange={this.handlePageChange}
									persistSortOrder={this.persistSortOrder}
								/>
							)}
						</Column>
					</Row>
					{showMandateDiffModal && <DifferenceModal closeModal={this.hideMandateDifferenceHeader} />}
				</Container>
			</LoadingLocalTakeover>
		);
	}
}

ManagePaymentLandingPage.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	hasApiCallInProgress: PropTypes.bool.isRequired,
	hasError: PropTypes.bool.isRequired,
	handleManagePaymentFilterChange: PropTypes.func.isRequired,
	handleActiveTabChange: PropTypes.func.isRequired,
	mandateActiveTab: PropTypes.string.isRequired,
	mandateActiveFilter: PropTypes.string.isRequired,
	handleView: PropTypes.func.isRequired,
	handleBackParent: PropTypes.func.isRequired,
	handleEdit: PropTypes.func.isRequired,
	handleCancelView: PropTypes.func.isRequired,
	handleRetry: PropTypes.func.isRequired,
	handleEditById: PropTypes.func.isRequired,
	chatBox: PropTypes.element.isRequired,
	hasIFTPayment: PropTypes.bool.isRequired,
	onDropDownChange: PropTypes.func.isRequired,
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropType)).isRequired,
	selectedAccount: PropTypes.string,
	renderPicker: PropTypes.func.isRequired,
	showPaymentDetail: PropTypes.bool.isRequired,
	totalNumberOfAccounts: PropTypes.number.isRequired,
	mandateActivePage: PropTypes.number.isRequired,
	setActivePage: PropTypes.func.isRequired,
};
export const withConnectWrapper = connect(mapState, mapDispatch)(ManagePaymentLandingPage);
export default withScrollTop(withContent({ content })(withConnectWrapper));
